export var ToastMapActionTypes;
(function (ToastMapActionTypes) {
    ToastMapActionTypes["ADD"] = "add";
    ToastMapActionTypes["REMOVE"] = "remove";
})(ToastMapActionTypes || (ToastMapActionTypes = {}));
//# sourceMappingURL=toast-map-action-types.js.map